/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Import_Verdict_Ready_TitleInputs */

const cs_import_verdict_ready_title = /** @type {(inputs: Import_Verdict_Ready_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Připraveno k potvrzení`)
};

const en_import_verdict_ready_title = /** @type {(inputs: Import_Verdict_Ready_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ready to commit`)
};

/**
* | output |
* | --- |
* | "Ready to commit" |
*
* @param {Import_Verdict_Ready_TitleInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const import_verdict_ready_title = /** @type {((inputs?: Import_Verdict_Ready_TitleInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Import_Verdict_Ready_TitleInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_import_verdict_ready_title(inputs)
	return cs_import_verdict_ready_title(inputs)
});